import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { ToolbarComponent } from './layout/toolbar/toolbar.component';
import { FooterComponent } from './layout/footer/footer.component';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContentLayoutBenefitsComponent } from './layout/content-layout-benefits/content-layout-benefits.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { HttpClientModule } from '@angular/common/http';
// import { CoreModule } from '@angular/flex-layout';
import { CoreModule } from './core/services/core.module';
import {EnvironmentServiceProvider} from './core/interceptors/dev-backend.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    DashboardLayoutComponent,
    ContentLayoutComponent,
    ContentLayoutBenefitsComponent,
    ToolbarComponent,
    FooterComponent,
    AdminLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    NgbModule,
    SweetAlert2Module,
    CoreModule,
  ],
  providers: [EnvironmentServiceProvider],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
